/* eslint-disable default-param-last */
import { DE_FLAG, EN_FLAG, FR_FLAG, fallBackImage } from "@platformx/shared/static-assets";
// Pulls in the MUI Theme/Typography/Button module augmentations declared in @platformx/themes
// (custom breakpoints, fontSize, and variant overrides) so they apply across this lib's TS program.
import type {} from "@platformx/themes";
import axios from "axios";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { ShowToastError } from "../components/ToastNotification/ToastNotification";
import {
  DefaultLanguage,
  DefaultLocale,
  OLD_CONTENT_TYPES,
  PROJECT_CATCH_ERROR_LIST,
  breakpoints,
} from "../constants/CommonConstants";
import { CONTENT_ICON, LanguageList, MESSAGE_API_ERROR, countries } from "./helperConstants";
import ToastService from "./ToastService";
import { Props } from "./types";

export const siteLevelSchema = {
  siteName: "X",
  siteURL: "https://platform-x.com",
  siteDescription: "Lorem Ipsum is simply dummy text of the printing",
  siteImage:
    "https://www.google.com/url?sa=i&url=https%3A%2F%2Fuicookies.com%2Ffree-html-contact-forms%2F&psig=AOvVaw2eVA8o8PsBkQZBaD49Qxf7&ust=1646374746446000&source=images&cd=vfe&ved=0CAsQjRxqFwoTCIC60qamqfYCFQAAAAAdAAAAABAO",
  facebookAppId: "Platform-X",
  twitterAppId: "Platform-X",
};

const errorRequest =
  "We have not been able to complete the requested action. Please try again later";
const headerData = {
  "Content-Type": "application/json",
  "Cache-Control": "no-cache",
};

/**
 * getCall
 * @param url string
 * @returns object
 */
export const getRestApiCall = async (url: string, locale?: string, sitename?: string) => {
  try {
    return await axios.get(url, {
      headers: {
        ...headerData,
        Locale: locale === "en" ? `${locale}` : `${locale}_${locale}`,
        ...(sitename && { sitename: sitename }),
      },
    });
  } catch (err: any) {
    ToastService.failToast(errorRequest);
    return err?.response;
  }
};

/**
 * postCall
 * @param url string
 * @param payload object
 * @returns object
 */
export const postRestApiCall = async (
  url: string,
  payload: any,
  locale?: string,
  site_host?: string,
) => {
  try {
    return await axios.post(url, payload, {
      headers: {
        ...headerData,
        ...(site_host && { sitehost: site_host }),
        Locale: locale === "en" ? `${locale}` : `${locale}_${locale}`,
      },
      withCredentials: true,
    });
  } catch (err: any) {
    // const { } = err.response;
    ToastService.failToast(errorRequest);
    return err?.response;
  }
};

/**
 * postCall
 * @param url string
 * @param payload object
 * @returns object
 */
export const putRestApiCall = async (
  url: string,
  payload: any,
  locale?: string,
  site_host?: string,
) => {
  try {
    return await axios.put(url, payload, {
      headers: {
        ...headerData,
        ...(site_host && { sitehost: site_host }),
        Locale: locale === "en" ? `${locale}` : `${locale}_${locale}`,
      },
      withCredentials: true,
    });
  } catch (err: any) {
    ToastService.failToast(errorRequest);
    return err?.response;
  }
};
//Modified this method with few more conditions
// export const structureDataUrlPoint = (content: any = {}, secondaryArgs: any = {}) => {
//   const { prelemBaseEndpoint = {}, currentPageURL } = secondaryArgs;
//   const { PublishEndPoint = "", language = "", buttonBaseUrl } = prelemBaseEndpoint;
//   const ContentUrl = `${PublishEndPoint}${language}/`;
//   const { Button_Action = "External", Button_RedirectURL = "", Button1_Value = "" } = content;
//   if (Button1_Value !== "" && Button1_Value !== "\n") {
//     if (Button_Action === "Internal") {
//       let id = Button_RedirectURL;
//       if (id && id.charAt(0) === "/") {
//         id = id.substring(1);
//       }
//       return ContentUrl + id;
//     } else if (Button_Action === "Content") {
//       const contentObjHandle = uriToJSON(content);
//       const { ContentType = "", currentPath = "" } = contentObjHandle;
//       const isGalleryArray = ["ImageGallery", "VideoGallery", "Gallery"].some(
//         (ele) => convertToLowerCase(ele) === convertToLowerCase(ContentType),
//       );
//       if (!isGalleryArray) {
//         //backSlash remove
//         const type = conCatUrlPath(ContentType);
//         let id = currentPath;
//         if (id && id.charAt(0) === "/") {
//           id = id.substring(1);
//         }
//         return `${ContentUrl}${type}${id}`;
//       }
//       return "";
//     }
//     return Button_RedirectURL;
//   } else {
//     return buttonBaseUrl + `${language}/` + currentPageURL;
//   }
// };

//Modified this method with few more conditions
export const completeButtonUrl = (
  actionType = "External",
  url = "https://www.hcltech.com",
  btnValue = "",
  currentPageURL = "",
  Button_Content = "",
  prelemBaseEndpoint,
) => {
  const content = {
    Button_Action: actionType,
    Button_RedirectURL: url,
    Button_Content: Button_Content,
    Button1_Value: btnValue,
  };
  const {
    PublishEndPoint = "",
    language = "en",
    buttonBaseUrl: btnBaseUrl = "",
  } = prelemBaseEndpoint;
  const ContentUrl = `${PublishEndPoint}${language}/`;

  if (btnValue !== "" && btnValue !== "\n") {
    if (actionType === "Internal") {
      // const pageName = JSON.parse(JSON.parse(url)); //url.slice(1);
      if (!url) {
        return "";
      }
      let pageName;
      try {
        pageName = JSON.parse(JSON.parse(url));
      } catch (e) {
        return "";
      }
      const nameWidoutSlash = pageName?.page.split("/");

      return `${ContentUrl}${nameWidoutSlash[1]}`;
      //return btnBaseUrl + urlwidoutSlash;
    } else if (actionType === "Content") {
      const contentObjHandle = uriToJSON(content);
      const { ContentType = "", currentPath = "" } = contentObjHandle;
      const isGalleryArray = ["ImageGallery", "VideoGallery", "Gallery"].some(
        (ele) => convertToLowerCase(ele) === convertToLowerCase(ContentType),
      );
      if (!isGalleryArray) {
        //backSlash remove
        const type = conCatUrlPath(ContentType);
        let id = currentPath;
        if (id && id.charAt(0) === "/") {
          id = id.substring(1);
        }
        return `${ContentUrl}${type}${id}`;
      }
      return "";
    }
    return url;
  } else {
    return btnBaseUrl + `${language}/` + currentPageURL;
  }
};
// export const completeButtonUrl = (
//   actionType = "External",
//   url = "https://www.hcltech.com",
//   btnBaseUrl = "",
//   btnValue = "",
//   currentPageURL = "",
//   language = "en",
// ) => {
//   if (btnValue !== "" && btnValue !== "\n") {
//     if (actionType === "Internal") {
//       const urlwidoutSlash = url.slice(1);
//       return btnBaseUrl + urlwidoutSlash;
//     }
//     return url;
//   } else {
//     return btnBaseUrl + `${language}/` + currentPageURL;
//   }
// };

export const completeButtonUrl2 = (
  internal = true,
  url = "https://www.hcltech.com",
  btnBaseUrl = "",
) => {
  if (internal) {
    const urlwidoutSlash = url.slice(1);
    return btnBaseUrl + urlwidoutSlash;
  }
  return url;
};

export const handleHtmlTags = (inputString: any) => {
  if (inputString) {
    return inputString.replace(/<[^>]*(>|$)|&nbsp;/g, "");
  }
  return inputString;
};

export const convertToLowerCase = (stringData: any = "") => {
  return ("" + stringData).toLowerCase();
};

export const capitalizeFirstLetter = (str = "") => {
  if (str) {
    try {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } catch (e) {
      return "";
    }
  }
  return "";
};

export const triggerAnalytics = ({ e, analytics, defaultObj, handleTrack = () => {} }: Props) => {
  if (!analytics?.isAuthoring && analytics?.isAnalyticsEnabled) {
    const buttonClickObj = {
      eventType: "Button Click",
      ...defaultObj,
      buttonURL: "",
      nameOfFileDownloaded: "",
      eventCategory: "Button Click",
      eventAction: "Click",
      eventLabel: e.currentTarget.innerText,
      eventValue: 1,
    };
    handleTrack(buttonClickObj?.eventType, buttonClickObj);
  }
};

export const debounce = (fn: any, ms = 300) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

export const checkImageUrlPath = (imgUrl = "") => {
  if (imgUrl.match(/(https?:\/\/.*\.(?:png|jpg|svg|webp|gif|avif))/i)) {
    return imgUrl;
  }
  return fallBackImage;
};

export const checkImageUrlPathString = (imgUrl) => {
  const imagePath: string = "";
  if (imgUrl.match(/(https?:\/\/.*\.(?:png|jpg|svg|webp|gif|avif))/i)) {
    return imgUrl; // Return the URL as a string
  }
  return imagePath; // Assuming fallBackImage is a string URL
};

export const getLandingPageURL = (endPoint: any, language: any, contentType: string, id: any) => {
  return `${endPoint}${language}/${contentType?.toLocaleLowerCase()}/${id}`;
};

/**
 * Builds the public URL path segment for a content item, slug-first with a
 * doc-path fallback. Returns a value that starts with "/" so callers can append
 * it after the brand/domain prefix (e.g. `${getSubDomain()}/${brand}${path}`).
 *
 * When the backend provides a SEO `slug`, the segment uses it (clean URL);
 * otherwise it falls back to the legacy `currentPageUrl` (internal doc path),
 * keeping behaviour identical until slugs are backfilled. Courses are handled
 * by the caller (query-param URL) and are intentionally not covered here.
 *
 * e.g. { tagName: "article", slug: "my-story" }            -> "/article/my-story"
 *      { tagName: "article", currentPageUrl: "/my-story-1778696199873" }
 *                                                          -> "/article/my-story-1778696199873"
 *
 * Dynamic / schema-based content types (e.g. Player Profile) already had a
 * working slug via the legacy `slug_format`/`slug_config` -> `navigation_slug`
 * mechanism before this field existed. That tier is preserved as a middle
 * fallback so migrating to the flat `slug` field can't regress those
 * already-live URLs while the backend backfills it: flat `slug` ->
 * `navigation_slug` -> doc-path. Note the `navigation_slug` tier omits the
 * `/content` prefix the other two tiers use — that's the pre-existing shape
 * production already serves, not something introduced here.
 */
export const getContentUrlPath = (details: {
  tagName?: string;
  slug?: string;
  currentPageUrl?: string;
  navigation_slug_format?: string;
  navigation_slug?: string;
}): string => {
  const tag = details?.tagName?.toLowerCase() || "";
  const slug = details?.slug?.trim();
  const currentPageUrl = details?.currentPageUrl || "";

  if (tag === "vod") {
    return slug ? `/video/${slug}` : `/video${currentPageUrl}`;
  }
  if (tag === "sitepage") {
    return slug ? `/${slug}` : `${currentPageUrl}`;
  }
  if (OLD_CONTENT_TYPES.some((item) => item?.toLowerCase() === tag)) {
    return slug ? `/${tag}/${slug}` : `/${tag}${currentPageUrl}`;
  }

  // Dynamic / schema-based content types (e.g. Player Profile) live under /content.
  if (slug) {
    return `/content/${tag}/${slug}`;
  }
  if (details?.navigation_slug_format && details?.navigation_slug) {
    return `/${tag}/${details.navigation_slug.toLowerCase()}`;
  }
  return `/content/${tag}${currentPageUrl}`;
};

export const getLandingPageURLwithoutSlash = (
  endPoint: any,
  language: any,
  contentType: string,
  id: any,
) => {
  const url = id?.startsWith("/") ? id?.substring(1) : id;
  return `${endPoint}${language}/${contentType.toLocaleLowerCase() === "vod" ? "video" : contentType.toLocaleLowerCase()}/${url}`;
};

export const getCourseLandingPageURL = (
  endPoint: any,
  language: any,
  contentType: string,
  id: any,
) => {
  return `${endPoint}${language}/course/course-details?courseId=${id}`;
};

//params ensPath update
export const encodeGetParams = (params: any = {}) => {
  return Object.entries(params)
    .map((key: any) =>
      key
        .map((k: any) => {
          const enCodeData = typeof k === "object" ? JSON.stringify(k) : k;
          return encodeURIComponent(enCodeData);
        })
        .join("="),
    )
    .join("&");
};

const getDefaultCroppedImage = (
  publishedImages: [],
  originalImage: any,
  defaultRatio = "landscape",
  secondaryArgs: any = {},
  isBackgroundImage = true,
  extension: string,
) => {
  const landscapeImg: any = publishedImages?.find(
    ({ aspect_ratio }: any) => aspect_ratio === defaultRatio,
  );
  const { folder_path: imgUrl = "" } = landscapeImg || { folder_path: "" };
  const { gcpUrl } = secondaryArgs;
  if (isBackgroundImage) {
    return `url('${gcpUrl}/${imgUrl}.avif'), url('${gcpUrl}/${imgUrl}.${originalImage.ext}')`;
  } else {
    if (imgUrl && extension) {
      return `${gcpUrl}/${imgUrl}.${extension}`;
    } else {
      return fallBackImage;
    }
  }
};

export const fetchCroppedUrl = (
  Url: string,
  publishedImages: [],
  imgOrder = {},
  originalImage: any,
  mediaQueryValues: any,
  secondaryArgs = {},
  isBackgroundImage: boolean,
  extension: string,
) => {
  let returnUrl = "";
  if (publishedImages && publishedImages?.length > 0) {
    const {
      less_than_320,
      less_than_600,
      less_than_768,
      less_than_1024,
      less_than_1280,
      less_than_1440,
    } = mediaQueryValues;
    if (less_than_320) {
      returnUrl = getDefaultCroppedImage(
        publishedImages,
        originalImage,
        imgOrder?.["320"] || breakpoints["320"],
        secondaryArgs,
        isBackgroundImage,
        extension,
      );
    } else if (less_than_600) {
      returnUrl = getDefaultCroppedImage(
        publishedImages,
        originalImage,
        imgOrder?.["600"] || breakpoints["600"],
        secondaryArgs,
        isBackgroundImage,
        extension,
      );
    } else if (less_than_768) {
      returnUrl = getDefaultCroppedImage(
        publishedImages,
        originalImage,
        imgOrder?.["768"] || breakpoints["768"],
        secondaryArgs,
        isBackgroundImage,
        extension,
      );
    } else if (less_than_1024) {
      returnUrl = getDefaultCroppedImage(
        publishedImages,
        originalImage,
        imgOrder?.["1024"] || breakpoints["1024"],
        secondaryArgs,
        isBackgroundImage,
        extension,
      );
    } else if (less_than_1280) {
      returnUrl = getDefaultCroppedImage(
        publishedImages,
        originalImage,
        imgOrder?.["1280"] || breakpoints["1280"],
        secondaryArgs,
        isBackgroundImage,
        extension,
      );
    } else if (less_than_1440) {
      returnUrl = getDefaultCroppedImage(
        publishedImages,
        originalImage,
        imgOrder?.["1440"] || breakpoints["1440"],
        secondaryArgs,
        isBackgroundImage,
        extension,
      );
    } else {
      returnUrl = getDefaultCroppedImage(
        publishedImages,
        originalImage,
        imgOrder?.["1440"] || breakpoints["1440"],
        secondaryArgs,
        isBackgroundImage,
        extension,
      );
    }
  } else {
    if (Url?.search("dspace") !== -1) {
      //normal dspace url
      returnUrl = Url;
    }
  }
  return returnUrl;
};
//string to parse convert
export const uriToJSON = (jsonObj: any = {}) => {
  const { Button_Content: buttonContent = "" } = jsonObj;
  if (buttonContent && typeof buttonContent === "string") {
    if (buttonContent.includes("ContentEnCodeParse")) {
      return JSON.parse(buttonContent);
    }
    return {};
  }
  return {};
};

export const internalPageUrlHandle = (pageName) => {
  if (pageName && typeof pageName === "string") {
    if (pageName.includes("internalPageUrl")) {
      const newObj = JSON.parse(pageName);
      return newObj?.page;
    }
    return pageName;
  }
  return pageName;
};

/**
 * string to parse convert
 * @param urijson
 * @returns object
 */
export const uriToJSONforButtonEditWindow = (urijson) => {
  if (urijson) {
    return JSON.parse(urijson);
  }
  return {};
};

export const completeExternalUrl = (str: string) => {
  let tarea = str;
  const tarea_regex = /^(http|https)/;
  if (!tarea_regex.test(String(str).toLowerCase())) {
    tarea = "https://" + str;
  }
  return tarea;
};

/**
 * last sting value is check "/"
 * @param ContentType
 * @returns string
 */

export const conCatUrlPath = (ContentType = "") => {
  if (ContentType) {
    const typeUrl =
      ContentType.charAt(ContentType.length - 1) === "/" ? `${ContentType}` : `${ContentType}/`;
    if (convertToLowerCase(typeUrl) === "vod/") {
      return "video/";
    }
    return convertToLowerCase(typeUrl);
  }
  return "";
};

export const pluralize = (value: number, word: string) => {
  return [0, 1].includes(value) ? word : `${word}s`;
};

export const structureDataUrlPoint = (content: any = {}, secondaryArgs: any = {}) => {
  const { prelemBaseEndpoint = {} } = secondaryArgs;
  const { PublishEndPoint = "", language = "" } = prelemBaseEndpoint;
  const ContentUrl = `${PublishEndPoint}${language}/`;
  const { Button_Action = "", Button_RedirectURL = "" } = content;

  if (Button_Action === "Internal") {
    let id = Button_RedirectURL;
    if (id && id.charAt(0) === "/") {
      id = id.substring(1);
    }
    return ContentUrl + id;
  } else if (Button_Action === "Content") {
    const contentObjHandle = uriToJSON(content);
    const { ContentType = "", currentPath = "" } = contentObjHandle;
    const isGalleryArray = ["ImageGallery", "VideoGallery", "Gallery"].some(
      (ele) => convertToLowerCase(ele) === convertToLowerCase(ContentType),
    );
    if (!isGalleryArray) {
      //backSlash remove
      const type = conCatUrlPath(ContentType);
      let id = currentPath;
      if (id && id.charAt(0) === "/") {
        id = id.substring(1);
      }
      return `${ContentUrl}${type}${id}`;
    }
    return "";
  }
  return "";
};

export const isScheduledInFuture = (dateTime: any): boolean => {
  if (Boolean(dateTime) === false) return false;
  const ts = new Date(dateTime).getTime();
  return Number.isNaN(ts) === false && ts > Date.now();
};

export const PlatFormXDateTimeFormat = (dataTime: any = "", requiredTime: boolean = true) => {
  if (dataTime) {
    const assign: any = new Date(dataTime);
    if (assign !== "Invalid Date" && !isNaN(assign)) {
      return requiredTime
        ? format(new Date(dataTime), "MMM d, yyyy | hh:mm a")
        : format(new Date(dataTime), "MMM d, yyyy");
    }
    return dataTime;
  } else {
    return "-";
  }
};

/**
 * Calculate age based on the provided date of birth
 * @param dob string (format: YYYY-MM-DD)
 * @returns number
 */
export const calculateAge = (dob: string): number => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

/**
 * currency based symbol
 * @param currency string
 * @returns string
 */
export const currencyBasedIcon = (currency: string) => {
  if (convertToLowerCase(currency) === "usd") {
    return "$";
  } else if (convertToLowerCase(currency) === "inr") {
    return "₹";
  }
  return "";
};

/**
 * allow only number
 * @param e objet
 */
export const allowOnlyNumberInputData = (e: any) => {
  const values = e?.target?.value;
  const number = values.replace(/[^0-9]/g, "");
  e.target.value = number;
};

/**
 * allow only char
 * @param e objet
 */
export const allowOnlyShippingLetterInputData = (e: any) => {
  const values = e?.target?.value;
  const number = values.replace(/[^a-zA-z(-,.,')]/g, "");
  e.target.value = number;
};

/**
 * allow only char
 * @param e objet
 */
export const allowOnlyLetterInputData = (e: any) => {
  const values = e?.target?.value;
  const number = values.replace(/[^a-zA-z]/g, "");
  e.target.value = number;
};

/**
 *
 * @param errors object
 * @returns boolean
 */
export const inputEmptyFieldValidate = (errors = {}) => {
  let valid = true;
  Object.values(errors).forEach((ele) => {
    if (ele === "") {
      valid = false;
    }
  });
  return valid;
};

/**
 *
 * @param errors object
 * @returns boolean
 */
export const inputNonEmptyFieldValidate = (errors = {}) => {
  let valid = true;
  Object.values(errors).forEach((ele) => {
    if (ele !== "") {
      valid = false;
    }
  });
  return valid;
};

/**
 * Decimal Values
 * @param value Actual value to formate
 * @param toFixed number of decimal which we have to show after decimal value
 * @returns float
 */
export const formateNumber = (value: number, toFixedVal?: number) => {
  if (!isNaN(value)) {
    return (Math.round(value * 100) / 100).toFixed(
      !isNaN(toFixedVal as number) ? (toFixedVal as number) : 2,
    );
  }
  return value;
};

/**
 * email validate
 * @param email string
 * @returns boolean
 */
export const emailValidate = (email = "") => {
  // const reg = /^\s*([\w+-]+\.)*[\w+]+@([\w+-]+\.)*([\w+-]+\.[a-zA-Z]{2,6})+\s*$/;
  const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!reg.test(email)) {
    return false;
  }
  return true;
};

export const priceRegx = /^\d+(\.\d{1,2})?$/;

export const getGridValues = (cardArr: any, index?: number) => {
  let sm = 4,
    em = 3,
    cardType = "XCard1";
  if (cardArr?.length === 1) {
    sm = 12;
    em = 12;
    cardType = "XCard3";
  } else if (cardArr?.length === 2) {
    sm = 6;
    em = 6;
    cardType = "XCard2";
  } else if (cardArr?.length === 3) {
    if (index === 0) {
      em = 6;
      sm = 12;
      cardType = "XCard2";
    } else {
      em = 3;
      sm = 6;
      cardType = "XCard1";
    }
  } else if (cardArr?.length === 4) {
    sm = 6;
    em = 3;
    cardType = "XCard1";
  }
  return { sm, em, cardType };
};
export function sleep(ms: any) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export const getCountryFlag = (country: string) => {
  const countryObj = countries.find((item) => item.label === country);
  return `https://flagcdn.com/w40/${countryObj?.code?.toLowerCase()}.png`;
};

export const eComTypeUriToJSON = (jsonObj: any = {}) => {
  const { Button_Content: buttonContent = "" } = jsonObj;
  if (buttonContent && typeof buttonContent === "string") {
    if (buttonContent.includes("ecomEnCodeParse")) {
      return JSON.parse(buttonContent);
    }
    return {};
  }
  return {};
};

export const getCurrentLang = () => {
  let lang = "";
  const split = window?.location.pathname.split("/");

  if (LanguageList().find((x) => x.id === split[2])) {
    const [, , x] = split;
    lang = x;
  } else {
    lang = DefaultLocale;
  }
  return lang;
};

export const getCurrentLangName = () => {
  let lang = "";
  const split = window?.location.pathname.split("/");
  const selLang = LanguageList().find((x) => x.id === split[2]);
  if (selLang) {
    lang = selLang.label;
  } else {
    lang = DefaultLanguage;
  }
  return lang;
};

export const onBackButtonEvent = (e, unsavedChanges, setDialogOpen) => {
  e.preventDefault();
  // eslint-disable-next-line no-restricted-globals
  window.history.pushState(null, "", window.location.pathname + location?.search);
  if (unsavedChanges) {
    setDialogOpen(true);
  } else {
    return;
  }
};

export const unloadCallback = (event, unsavedChanges) => {
  event.preventDefault();
  if (unsavedChanges) {
    event.returnValue = "";
    return "";
  }
};

export const getSelectedSite = () => {
  const splitPath = window?.location.pathname.split("/");
  const [, x] = splitPath;
  const site = x;

  if (["en", "fr", "de"].includes(site)) {
    return localStorage.getItem("selectedSite") || "";
  }

  return site || "";
};

const SELECTED_BRAND_KEY = "selectedBrand";
const SELECTED_BRAND_NAME_KEY = "selectedBrandName";
const MULTI_BRANDS_ENABLED_KEY = "multiBrandsEnabled";
const MULTI_BRANDS_LIST_KEY = "multiBrandsList";
export type BrandDetail = {
  brandId: string;
  brandName: string;
};

export const isMultiBrandsEnabled = (): boolean => {
  if (typeof localStorage !== "object") return false;
  return localStorage.getItem(MULTI_BRANDS_ENABLED_KEY) === "true";
};

export const getSelectedBrand = (): string => {
  if (!isMultiBrandsEnabled()) return "";
  if (typeof localStorage === "object") return localStorage.getItem(SELECTED_BRAND_KEY) || "";
  return "";
};

export const getSelectedBrandName = (): string => {
  if (!isMultiBrandsEnabled()) return "";
  if (typeof localStorage === "object") return localStorage.getItem(SELECTED_BRAND_NAME_KEY) || "";
  return "";
};

export const setSelectedBrandDetails = (brandId: string, brandName: string): void => {
  if (!isMultiBrandsEnabled()) return;
  if (typeof localStorage !== "object") return;
  localStorage.setItem(SELECTED_BRAND_KEY, brandId);
  localStorage.setItem(SELECTED_BRAND_NAME_KEY, brandName);
};

export const getStoredBrandDetails = (): BrandDetail[] => {
  if (typeof localStorage !== "object") return [];
  try {
    const stored = localStorage.getItem(MULTI_BRANDS_LIST_KEY);
    return stored ? (JSON.parse(stored) as BrandDetail[]) : [];
  } catch {
    return [];
  }
};

export const appendBrandNameIfPresent = <T extends Record<string, any>>(
  input: T,
  isShared = false,
): T => {
  const brandId = getSelectedBrand();
  if (isShared || !brandId) return input;
  if (input?.CommonFields && typeof input.CommonFields === "object") {
    return {
      ...input,
      CommonFields: {
        ...input.CommonFields,
        brand_name: brandId,
      },
    };
  }
  return { ...input, brand_name: brandId };
};

export const getSelectedSiteUrl = () => {
  const userSession =
    typeof localStorage !== "undefined" ? localStorage.getItem("userSession") : null;
  const selectedSite = getSelectedSite();
  return userSession && selectedSite
    ? JSON.parse(userSession)?.userInfo?.preferred_sites_urls?.[selectedSite] || null
    : null;
};

export const getSelectedRoute = () => {
  const splitPath = window?.location.pathname.split("/");
  const [, x] = splitPath;
  const site = x;

  if (["en", "fr", "de"].includes(site)) {
    return "";
  }

  return site || "";
};

export const getUserExpSubDomain = () => {
  const sessions = localStorage.getItem("userSession") || "";
  const storedSession = JSON.parse(sessions);
  const site_url = storedSession?.userInfo?.preferred_sites_urls;
  const domain = site_url[getSelectedSite() || ""]?.replace(".com.", ".com");
  if (domain) {
    return domain;
  } else {
    return null;
  }
};

export const getSubDomain = () => {
  const sessions = localStorage.getItem("userSession") || "";
  if (sessions) {
    const storedSession = JSON.parse(sessions);
    const site_url = storedSession?.userInfo?.preferred_sites_urls;
    const selectedSite: string = getSelectedSite() || "";
    const domain = site_url[selectedSite]?.replace(".com.", ".com");
    if (domain) {
      if (domain.startsWith("http://")) {
        return domain.replace("http://", "https://");
      } else if (!domain.startsWith("https://")) {
        return `https://${domain}`;
      }
      return domain;
    }
  }
  return null; // Return null if `domain` is null or undefined
};

export const getCurrentPathName = () => {
  const { pathname } = window?.location || "";
  const split = pathname.split("/");

  if (LanguageList().find(({ id }) => id === split[2])) {
    return `/${split.slice(3).join("/")}`;
  } else {
    return pathname;
  }
};

export const trimString = (string: string, length: number) => {
  if (string) {
    const trimmedString = string.length > length ? `${string.substring(0, length - 3)}...` : string;
    return trimmedString;
  }
  return "";
};
// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace Intl {
  type Key = "calendar" | "collation" | "currency" | "numberingSystem" | "timeZone" | "unit";
  // eslint-disable-next-line no-unused-vars
  function supportedValuesOf(input: Key): string[];
}

//Set page settings wit default values on page creation
export function setDefaultPageSettings(
  name: string,
  description?: string,
  tags?: string[],
  url?: string,
) {
  return {
    PageName: name,
    PageDescription: description !== undefined ? description : "",
    PageTags: tags !== undefined ? [...tags] : [],
    PageURL: url !== undefined ? url : "",
    PageViewer: "",
    PageCaching: false,
    PageMobileFriendly: false,
    SeoTitle: `${name} | ${siteLevelSchema.siteName}`,
    SeoDescription: description !== undefined ? description : "",
    SeoKeywords: tags !== undefined ? [...tags] : [],
    SeoBlockIndexing: false,
    SocialOgTitle: `${name} | ${siteLevelSchema.siteName}`,
    SocialOgDescription: description !== undefined ? description : "",
    SocialOgSiteName: `${name} | ${siteLevelSchema.siteName}`,
    SocialOgType: "Website",
    SocialOgURL: url !== undefined ? url : "",
    SocialOgLocale: "en_US",
    SocialOgImage: "",
    SocialOgTwitterTitle: `${name} | ${siteLevelSchema.siteName}`,
    SocialOgTwitterDescription: description !== undefined ? description : "",
    SocialOgTwitterImage: "",
    SocialOgTwitterURL: url !== undefined ? url : "",
    SocialTwitterCardSize: "summary_large_image",
  };
}

export const formatChildren = (children: any, content: any) => {
  const Children: any = [];
  for (let i = 0; i < children.length; i++) {
    const instance = { ...children[i] };
    delete instance.__typename;
    instance.content = content[instance.DocumentPath];
    Children.push(instance);
  }
  return Children;
};

export const formatContentTitle = (title = "") => {
  return title
    ?.replace(/[_-]/g, " ")
    ?.replace(/([a-z])([0-9])/gi, "$1 $2")
    ?.replace(/([0-9])([a-z])/gi, "$1 $2")
    ?.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export const capitalizeWords = (title = "") => {
  return title.toLowerCase().replace(/(?:^|\s)\S/g, (char) => char.toUpperCase());
};

export const timeZoneData = () => {
  return Intl.supportedValuesOf("timeZone");
};
const aryIannaTimeZones = timeZoneData();
export const getUniqueTimeZone = () => {
  const data: any = [];
  aryIannaTimeZones.forEach((timeZone) => {
    // let strTime = new Date().toLocaleTimeString([], {
    //   timeZone: `${timeZone}`,
    //   hour12: false,
    // });
    const strTime = new Date().toLocaleString([], {
      timeZone: `${timeZone}`,
      hour12: false,
    });
    const time = new Date(strTime).toTimeString().slice(0, -21);
    data.push({ label: `${timeZone} ${time}(IST)`, time: `${strTime}` });
  });
  // const uniqueItems = data.filter(
  //   (item: any, index: any, self: any) =>
  //     index === self.findIndex((x: any) => x.time === item.time),
  // );
  return data;
};

export const onClickCardUrlNavigate = (id: string, content: any, secondaryArgs: any) => {
  const contentType =
    content?.ContentType?.toLowerCase() ||
    content?.content_type?.toLowerCase() ||
    content?._tag_name?.toLowerCase() ||
    "";
  if (typeof window !== "undefined") {
    // let url = "";
    if (id && id.charAt(0) === "/") {
      // eslint-disable-next-line no-param-reassign
      id = id.substring(1);
    }

    // Prefer the SEO slug when the backend provides one; otherwise fall back to
    // the legacy doc-path segment so links stay valid until slugs are backfilled.
    const urlSegment = content?.slug?.trim() || id;

    if (contentType === "vod") {
      return getLandingPageURL(
        secondaryArgs?.prelemBaseEndpoint?.PublishEndPoint,
        secondaryArgs?.prelemBaseEndpoint?.language,
        "video",
        urlSegment,
      );
    } else if (content.ContentType === "Course") {
      return getCourseLandingPageURL(
        secondaryArgs?.prelemBaseEndpoint?.PublishEndPoint,
        secondaryArgs?.prelemBaseEndpoint?.language,
        content.ContentType,
        id,
      );
    } else if (convertToLowerCase(content.ContentType) === "community") {
      return id;
    } else if (OLD_CONTENT_TYPES.some((item) => item?.toLowerCase() === contentType)) {
      return getLandingPageURL(
        secondaryArgs?.prelemBaseEndpoint?.PublishEndPoint,
        secondaryArgs?.prelemBaseEndpoint?.language,
        contentType,
        urlSegment,
      );
    } else {
      return getLandingPageURL(
        secondaryArgs?.prelemBaseEndpoint?.PublishEndPoint,
        `${secondaryArgs?.prelemBaseEndpoint?.language}/content`,
        contentType,
        urlSegment,
      );
    }
  }
  return "";
};

export const getFormattedImageUrl = (path: string, ext: string, secondaryArgs: any) => {
  if (path && ext) {
    const url = `${secondaryArgs?.gcpUrl}/${path}.${ext}`;

    if (url.match(/^https?:\/\/.+$/)) {
      return url;
    }
    return fallBackImage;
  }
  return fallBackImage;
};
export const getFormattedImageUrlString = (path: string, ext: string, secondaryArgs: any) => {
  // const imgPath:string=fallBackImage; #TODO Need to check
  if (path && ext) {
    const url = `${secondaryArgs?.gcpUrl}/${path}.${ext}`;
    if (url.match(/^https?:\/\/.+$/)) {
      return { src: url };
    }
    return { src: "" };
  }
  return { src: "" };
};
export const getRandomNumber = (min, max) => {
  return (min + ((max - min + 1) * crypto.getRandomValues(new Uint32Array(1))[0]) / 2 ** 32) | 0;
};
export const getRandomNumberAddon = (answerArray: any, min: number, max: number) => {
  if (answerArray?.length < max) {
    const existingNumbers = answerArray.map((arr: any) => arr.id);
    let randomNumber;
    do {
      randomNumber = getRandomNumber(min, max);
    } while (existingNumbers.includes(randomNumber?.toString()));
    return randomNumber;
  }
};
export const getImg = (content: any, secondaryArgs: any, index: number) => {
  const { prelemBaseEndpoint: { bucketUrl = "", bucketName = "" } = {} } = secondaryArgs;
  const ImageCompound_index = `ImageCompound_${index}`;
  const { original_image_relative_path, ext }: any =
    (content?.ImageCompound && content?.ImageCompound[ImageCompound_index]?.original_image) || {};
  const img = buildCDNURL(original_image_relative_path, ext, bucketUrl, bucketName);
  return img;
};

const CDN_BASE_URL = process.env.NX_PUBLIC_CDN_BASE_URL || process.env.NEXT_CDN_BASE_URL;
const GCP_URL = process.env.NX_PUBLIC_GCP_URL || process.env.NEXT_GCP_URL;
const BUCKET_NAME = process.env.NX_PUBLIC_BUCKET_NAME || process.env.NEXT_GCP_BUCKET_NAME;

export const buildBucketUrl = (
  path: string,
  ext: string = "",
  bucketUrl: string = "",
  bucketName: string = "",
): string => {
  if (!path) return "";
  const base = bucketUrl || GCP_URL;
  const bucketNameFinal = bucketName || BUCKET_NAME;
  const fullPath = ext && !/\.[a-z0-9]+$/i.test(path) ? `${path}.${ext}` : path;
  return bucketNameFinal ? `${base}/${bucketNameFinal}/${fullPath}` : `${base}/${fullPath}`;
};

export const buildCDNURL = (
  url,
  extension = "",
  bucketUrl = "",
  bucketName = "",
  options = "quality=85,format=webp",
) => {
  const sourceUrl = buildBucketUrl(url, extension, bucketUrl, bucketName);

  if (!sourceUrl) {
    return "";
  }

  const thumbnailUrl = options
    ? `${CDN_BASE_URL}/${options}/${sourceUrl}`
    : `${CDN_BASE_URL}/${sourceUrl}`;

  return thumbnailUrl;
};

export const buildImageObjectWithColor = (
  content: {
    background_content?: { Color?: string };
    content_image?: { original_image?: { original_image_relative_path?: string; ext?: string } };
    Thumbnail?: { Url?: string; ext?: string };
  },
  secondaryArgs: { prelemBaseEndpoint?: { bucketUrl?: string; bucketName?: string } },
): { imageUrl: string; color: string | null } => {
  const {
    background_content: { Color = "" } = {},
    content_image: { original_image: { original_image_relative_path = "", ext = "" } = {} } = {},
    Thumbnail: { Url = "", ext: ext1 = "" } = {},
  } = content;
  const { prelemBaseEndpoint: { bucketUrl = "", bucketName = "" } = {} } = secondaryArgs;
  const imageColorObject: { imageUrl: string; color: string | null } = {
    imageUrl: "",
    color: null,
  };
  if (Color === "") {
    const image = buildCDNURL(
      original_image_relative_path || Url,
      ext || ext1,
      bucketUrl,
      bucketName,
      "quality=85,format=webp",
    );
    return {
      ...imageColorObject,
      imageUrl: image,
    };
  } else {
    return { ...imageColorObject, color: Color };
  }
};

export const createIconUrl = (secondaryArgs: any, imgUrl: string) => {
  return `${secondaryArgs?.gcpUrl}${imgUrl}`;
};

export const createIconUrl2 = (secondaryArgs: any, imgUrl: string) => {
  return `${secondaryArgs?.gcpUrl}/${imgUrl}`;
};

export const createSliderArray = (originalArray: any, itemsPerRow: any) => {
  const windowWidth = window.innerWidth;
  let itemsPerSlide;
  if (windowWidth >= 1280) {
    itemsPerSlide = itemsPerRow.lg;
  } else if (windowWidth >= 1024) {
    itemsPerSlide = itemsPerRow.em;
  } else if (windowWidth >= 768) {
    itemsPerSlide = itemsPerRow.md;
  } else if (windowWidth >= 500) {
    itemsPerSlide = itemsPerRow.sm;
  } else {
    itemsPerSlide = itemsPerRow.xs;
  }

  const sliderArray: object[][] = [];
  if (originalArray && originalArray.length) {
    for (let i = 0; i < originalArray.length; i += itemsPerSlide) {
      sliderArray.push(originalArray.slice(i, i + itemsPerSlide));
    }
    return sliderArray;
  }
};

export const getFlag = (code = "") => {
  switch (code || getCurrentLang()) {
    case "en":
      return EN_FLAG;
    case "fr":
      return FR_FLAG;
    case "de":
      return DE_FLAG;
    default:
      return EN_FLAG;
  }
};

// setDuplicate Page settings
export function setDuplicatePageSettings(name: string, url: string, pageSettings) {
  const pageSettingsCopy = {
    ...pageSettings,
    PageName: name,
    PageURL: `${getSubDomain()}/${url}`,
    SeoTitle: `${name} | ${siteLevelSchema.siteName}`,
    SocialOgTitle: `${name} | ${siteLevelSchema.siteName}`,
    SocialOgSiteName: `${name} | ${siteLevelSchema.siteName}`,
    SocialOgURL: `${getSubDomain()}/${url}`,
    SocialOgTwitterTitle: `${name} | ${siteLevelSchema.siteName}`,
    SocialOgTwitterURL: `${getSubDomain()}/${url}`,
    IsSchedulePublish: false,
    IsScheduleUnpublish: false,
    SchedulePublishDateTime: "",
    ScheduleUnpublishDateTime: "",
  };
  return pageSettingsCopy;
}

export const formatChildrenForPageDuplicate = (pageModel, pageName, pageUrl, currentUser) => {
  const ChildrenArray: any = [];
  pageModel.Page = pageUrl;
  pageModel.Title = pageName;
  pageModel.CurrentPageURL = `/${pageUrl}`;
  pageModel.DevelopedBy = currentUser;
  pageModel.Page_LastModificationDate = new Date();
  pageModel.PageSettings = setDuplicatePageSettings(pageName, pageUrl, pageModel.PageSettings);
  if (pageModel?.Children) {
    for (let i = 0; i < pageModel?.Children?.length; i++) {
      const instance = { ...pageModel.Children[i] };
      delete instance.content;
      ChildrenArray.push(instance);
    }
  }
  pageModel.Children = ChildrenArray;
  return pageModel;
};

export function removeParamsFromURL(sParam) {
  let url = `${window.location.href.split("?")[0]}?`;
  const sPageURL = decodeURIComponent(window.location.search.substring(1));
  const sURLVariables = sPageURL.split("&");
  let sParameterName;
  let i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");
    if (sParameterName[0] !== sParam) {
      url = `${url + sParameterName[0]}=${sParameterName[1]}&`;
    }
  }
  return url.substring(0, url.length - 1);
}

export const getDomainUrl = (host) => {
  return `http://${host}/`;
};

export const sendBtnBaseUrl = () => {
  return process.env.NX_PUBLIC_PUBLISH_APP_URL;
};

export const snowplowSchemaUrl = () => {
  return {
    pageImpressionSchema: process.env.NX_PUBLIC_PAGE_IMPRESSIONS_SCHEMA,
    prelemImpressionSchema: process.env.NX_PUBLIC_SNOWPLOW_PRELEM_IMPRESSIONS,
    clickImpressionSchema: process.env.NX_PUBLIC_SNOWPLOW_CLICK_IMPRESSIONS,
    userRegisterImpressionSchema: process.env.NX_PUBLIC_SNOWPLOW_REGISTER_USER_IMPRESSIONS,
    environment: process.env.NX_PUBLIC_ELASTIC_APM_ENVIRONMENT,
    gcpUrl: process.env.NX_PUBLIC_GCP_URL,
  };
};

export async function getData(url = "") {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.utilities}:HTTP error! Status`, response.status);
    }

    return response.json();
  } catch (error) {
    ShowToastError(MESSAGE_API_ERROR);
    console.error(`${PROJECT_CATCH_ERROR_LIST.site_setting}:getData`, error);
  }
}
export async function postData(url = "", data = {}, site_host = "") {
  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        ...(site_host && { sitehost: site_host }),
      },
    });

    return response;
  } catch (error: any) {
    ShowToastError(MESSAGE_API_ERROR);
    return error?.response?.data;
  }
}

export const getIcon = (contentType) => {
  const gcpUrl = `${process.env.NX_PUBLIC_GCP_URL}/`;
  switch (convertToLowerCase(contentType)) {
    case "article":
      return `${gcpUrl}${CONTENT_ICON.ARTICLE}`;
    case "poll":
      return `${gcpUrl}${CONTENT_ICON.POLL}`;
    case "quiz":
      return `${gcpUrl}${CONTENT_ICON.QUIZ}`;
    case "event":
      return `${gcpUrl}${CONTENT_ICON.EVENT}`;
    case "vod":
      return `${gcpUrl}${CONTENT_ICON.VOD}`;
    default:
      return `${gcpUrl}${CONTENT_ICON.ARTICLE}`;
  }
};

export const apiCallForBlogs = async (url, payload = {}, type = "put") => {
  try {
    return await axios[type](url, payload, {
      headers: {
        ...headerData,
        sitename: getSelectedSite(),
        sitehost: getSubDomain(),
      },
    });
  } catch (err: any) {
    return err.response;
  }
};

export const isJSONString = (str: any) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const safeJsonParse = (jsonString: string, fallback: any = {}): any => {
  if (!jsonString || typeof jsonString !== "string") {
    return fallback;
  }
  // Handle empty or whitespace-only strings
  const trimmedString = jsonString.trim();
  if (trimmedString === "" || trimmedString === "null" || trimmedString === "undefined") {
    return fallback;
  }
  try {
    const parsed = JSON.parse(trimmedString);
    // Validate parsed result
    if (parsed === null || parsed === undefined) {
      return fallback;
    }
    // Ensure parsed result is an object for template form values
    if (
      typeof parsed !== "object" ||
      (Array.isArray(parsed) && parsed.length > 0 && typeof parsed === "string")
    ) {
      return safeJsonParse(parsed);
    }
    return parsed;
  } catch (error) {
    console.error("JSON parsing error:", error);
    return fallback;
  }
};

export const getThumbImages = (thumbnail: any) => {
  if (isJSONString(thumbnail)) {
    const thumbnailObject = JSON.parse(thumbnail);
    return thumbnailObject && thumbnailObject?.images ? thumbnailObject?.images : [];
  }
  return thumbnail?.images || null;
};

export const makeCreateContentPath = (contentType: string, category: string) => {
  return `/update/${category.toLowerCase()}/${contentType.toLowerCase()}`;
};

export const compareTwoArraysIgnoringOrder = (a = [], b: string[] = []) => {
  if (a.length !== b.length) {
    return false;
  }

  let isEqual = true;
  a.forEach((element) => {
    if (!b.includes(element)) {
      isEqual = false;
    }
  });

  return isEqual;
};

export const hideMarkedFeatureIcon = (pathArray) => {
  const items = ["asset", "site-setting"];
  return !items.some((ele) => ele === pathArray?.[3]);
};
export const navigateBasedRole = (navigate) => {
  const selectedSite = localStorage.getItem("selectedSite");
  if (selectedSite === "system") {
    navigate("/sites/site-listing");
  } else {
    navigate("/dashboard");
  }
};
export const isValueExist = (tempArr, menuItemName, editData) => {
  return tempArr.some((val) => {
    // return val
    //   ? val.Label.toLowerCase() === menuItemName.toLowerCase() &&
    //       val.Label.toLowerCase() !== editData?.Label.toLowerCase()
    //   : "";
    return (
      val.Label.toLowerCase() === menuItemName.toLowerCase() &&
      val.Label.toLowerCase() !== editData?.Label.toLowerCase()
    );
  });
};

export const GetLoginDetails = () => {
  let userId = "",
    userName = "",
    role = "";
  let sessions: any = localStorage.getItem("userSession");
  if (typeof sessions === "string") {
    sessions = JSON.parse(sessions);
    userId = sessions?.userInfo?.user_id;
    userName = `${sessions?.userInfo?.first_name} ${sessions?.userInfo?.last_name}`;
    role = sessions?.role;
  }
  return { userId, userName, role };
};

export const generateRandomNumber = () => {
  const { crypto } = window;
  const arrayData32 = new Uint32Array(1);
  // Compliant for security-sensitive use cases
  const randomNumber = crypto.getRandomValues(arrayData32);
  return randomNumber?.[0] || 0;
};

export function isSubsequence(s, t) {
  let i = 0,
    j = 0;
  while (i < s.length && j < t.length) {
    if (s[i] === t[j]) {
      i++;
    }
    j++;
  }
  return i === s.length;
}
export function isRPIEnabled(prelemBaseEndpoint: any) {
  if (
    prelemBaseEndpoint?.allowedAnalyticsProviders?.length > 0 &&
    prelemBaseEndpoint.allowedAnalyticsProviders.includes("RPI")
  ) {
    return true;
  }
  return false;
}
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}

export const getRelativeTime = (publishedDate: string | number | Date): string => {
  const published = new Date(publishedDate);
  const now = new Date();

  const diffInMs = now.getTime() - published.getTime();

  const minutes = Math.floor(diffInMs / (1000 * 60));
  const hours = Math.floor(diffInMs / (1000 * 60 * 60));
  const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(days / 7);

  if (minutes < 60) {
    return `${minutes} m`;
  } else if (hours < 24) {
    return `${hours} h`;
  } else if (days < 7) {
    return `${days} d`;
  } else if (weeks < 4) {
    return `${weeks} w`;
  } else {
    // Always show in "Oct's 25" format
    const monthName = published.toLocaleDateString("en-US", { month: "short" });
    const shortYear = String(published.getFullYear()).slice(-2);
    return `${monthName}'s ${shortYear}`;
  }
};

/**
 * Populates a slug template with values from a config object and returns the
 * resulting string.
 *
 * @example
 * populateSlug("${title}-${lastName_x_str}-${playerId_x_str}", {
 *   title: "MCILROY",
 *   lastName_x_str: "Rory",
 *   playerId_x_str: "34024",
 * });
 * // => "MCILROY-Rory-34024"
 *
 * Placeholders whose key is missing from `slugConfig` are replaced with an
 * empty string so a single missing value can never crash the caller.
 *
 * When `slugify` is `true`, the populated string is normalised into a
 * URL-safe slug (lower-cased, non-alphanumeric runs collapsed to single
 * hyphens, leading/trailing hyphens trimmed):
 *
 * @example
 * populateSlug("${title}-${tournament_id_x_str}", {
 *   title: "Danish Golf Championship",
 *   tournament_id_x_str: "2026131",
 * }, true);
 * // => "danish-golf-championship-2026131"
 *
 * @param slugFormat  Template string containing `${key}` placeholders.
 * @param slugConfig  Map of placeholder keys to their replacement values.
 * @param slugify     When true, normalise the result into a URL-safe slug.
 */
export const populateSlug = (
  slugFormat?: string,
  slugConfig?: Record<string, string | number | null | undefined>,
  slugify = false,
): string => {
  if (!slugFormat) return "";
  const populated = slugFormat.replace(/\$\{\s*([\w.]+)\s*\}/g, (_match, key) => {
    const value = slugConfig?.[key];
    return value === undefined || value === null ? "" : String(value);
  });
  if (!slugify) return populated;
  return populated
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};
